export default __webpack_public_path__ + "static/media/property_7.8213664f.png";